import React from 'react';
import BarChart from './BarChart';
import styled from 'styled-components';
import { useIntl } from 'react-intl';
import messages from './messages';

const Container = styled.div`
    display: flex;
    align-items: center;
    margin-top: 4em;
`;
const Graphs = ({ formState }) => {
    const intl = useIntl();

    const occData = [
        {
            name: intl.formatMessage(messages.occupancyGraphLabel),
            'Before change': parseInt(formState.forecastedOcc, 10),
            'After change': parseInt(formState.newOccupancy, 10),
        },
    ];

    const newTotalRooms = parseInt(formState.actualRooms, 10) + parseInt(formState.forecastedActual, 10);

    const roomsData = [
        {
            name: intl.formatMessage(messages.roomsGraphLabel),
            'Before change': parseInt(formState.forecastedActual, 10),
            'After change': newTotalRooms,
        },
    ];

    return (
        <Container>
            <BarChart width="50%" data={occData} />
            <BarChart width="50%" data={roomsData} />
        </Container>
    );
};

export default Graphs;
